import React, { useCallback, useRef, useState } from 'react'

import logoRed from 'assets/images/logo-red.svg'
import logo from 'assets/images/logo.webp'
import classNames from 'classnames/bind'
import { useWrapperContext } from 'components/Wrapper/Wrapper'
import { Link } from 'react-router-dom'
import { Button } from 'shared/components'
import { delay } from 'shared/utils'

import styles from './Header.module.scss'
import Menu from './Menu/Menu'

const cx = classNames.bind(styles)

const Header = (): JSX.Element => {
  const getIsTransparent = () => window.scrollY < 1
  const getIsScrollingViewport = () => window.scrollY >= window.innerHeight
  const menuRef = useRef<HTMLDivElement>(null)
  const [isMenuOpened, setIsMenuOpened] = useState(false)
  const [isTransparent, setIsTransparent] = useState(getIsTransparent())
  const [headerPadding, setHeaderPadding] = useState('')
  const [isScrollViewport, setIsScrollViewport] = useState(
    getIsScrollingViewport()
  )
  const { isHeaderFixed, headerWhite } = useWrapperContext()
  const headerClasses = cx({
    header: true,
    menuOpened: isMenuOpened,
    white: headerWhite,
    transparent: isTransparent,
    fixed: isHeaderFixed || isScrollViewport,
  })

  const menuBtnClasses = cx({
    menu__button: true,
    active: isMenuOpened,
  })

  const menuClasses = cx(
    'col-menu__items',
    'col-sm-12 col-sm-offset-0 col-xs-11 col-xs-offset-1',
    {
      opened: isMenuOpened,
    }
  )

  const toggleMenu = (e?: React.MouseEvent<HTMLButtonElement>) => {
    const newOpenState = !isMenuOpened
    setIsMenuOpened(newOpenState)

    const node = menuRef.current as HTMLDivElement

    if (menuRef?.current) {
      if (newOpenState) {
        // скролл должен появляться после того, как меню полностью открылось
        // 400 - transition duration из стилей
        delay(() => {
          node.style.overflowY = 'auto'
        }, 400)
      } else {
        // а скрывать скролл нужно в начале анимации закрытия
        node.style.overflowY = ''
      }
    }

    const target = e?.target as HTMLButtonElement
    delay(() => target?.blur(), 1000)
  }

  const handleScroll = useCallback(() => {
    const transparent = getIsTransparent()
    const isScrollingViewport = getIsScrollingViewport()
    if (transparent !== isTransparent) {
      setIsTransparent(transparent)
    }
    if (isScrollingViewport !== isScrollViewport) {
      setIsScrollViewport(isScrollingViewport)
    }
  }, [isScrollViewport, isTransparent])

  // const renderLoginBtn = () => {
  //   const btnType = headerWhite ? 'outline_light' : 'outline_dark'
  //
  //   return (
  //     <a href="https://originals.mtsmedia.ru">
  //       <Button
  //         className={styles.login__button}
  //         size="medium"
  //         btnType={btnType}
  //       >
  //         Войти
  //       </Button>
  //       <Button
  //         className={styles.login__button_small}
  //         size="small"
  //         btnType={btnType}
  //       >
  //         Войти
  //       </Button>
  //     </a>
  //   )
  // }

  React.useEffect(() => {
    const padding = isMenuOpened
      ? `${window.innerWidth - document.body.offsetWidth}px`
      : ''
    document.body.style.paddingRight = padding
    document.body.style.overflow = isMenuOpened ? 'hidden' : ''
    setHeaderPadding(padding)
    document.addEventListener('scroll', handleScroll)

    return () => {
      document.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll, isMenuOpened])

  return (
    <header className={headerClasses} style={{ paddingRight: headerPadding }}>
      <div className="container container-full">
        <div className={`${styles['row']} row`}>
          <Link to="/" className={styles['col-logo']}>
            <img src={headerWhite ? logoRed : logo} alt="logo" />
          </Link>

          <div className={styles['col-menu__action']}>
            <div className={styles['col-menu__action_row']}>
              {/*<div className={styles['col-menu__action_row_item']}>*/}
              {/*  {renderLoginBtn()}*/}
              {/*</div>*/}
              <div className={styles['col-menu__action_row_item']}>
                <button className={menuBtnClasses} onClick={toggleMenu}>
                  <span className={styles['line-top']}></span>
                  <span className={styles['line-middle']}></span>
                  <span className={styles['line-bottom']}></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles['menu-container']}>
        <div className={`container container-full ${styles.bg}`}>
          <div className="row">
            <div ref={menuRef} className={menuClasses}>
              <Menu toggleMenu={toggleMenu} />
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
